export default {
  name: "Dashboard",
  data() {
    return {
      data: {},
    };
  },
  computed: {
    unreadGuides() {
      return this.$store.state.admin.count_unread_guides;
    },
    todaySumSell() {
      return this.$store.state.admin.today_sum_sell;
    },
    totalSumSell() {
      return this.$store.state.admin.total_sum_sell;
    },
  },
};
